import 'vuetify/styles'
import { createVuetify, type ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VBtn } from 'vuetify/components';
import { appConfig } from '@/types/appConfig.type.ts';
import { phosphorVueIconSet } from '@/plugins/phosphor.ts';
import { fr, en } from 'vuetify/locale';
import { VDateInput } from "vuetify/labs/components";

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#d7a321',
    'on-primary': '#FFFFFF',
    secondary: '#ac821a',
    'on-secondary': '#FFFFFF',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    error: '#FF5252',
    inactive: '#8E8E8E',
    disabled: '#E0E0E0',
    link: '#d7a321',
  }
}

export default createVuetify({
  locale: {
    locale: appConfig.VITE_DEFAULT_LOCALE,
    fallback: appConfig.VITE_FALLBACK_LOCALE,
    messages: {
      fr: {
        ...fr,
      },
      en: {
        ...en,
      }
    }
  },
  date: {
    locale: {
      fr: 'fr-FR'
    }
  },
  icons: {
    defaultSet: 'phosphorVue',
    sets: {
      phosphorVue: phosphorVueIconSet,
    },
    aliases: {
      prev: 'PhCaretLeft',
      next: 'PhCaretRight',
      sortAsc: 'PhCaretDown',
      sortDesc: 'PhCaretUp',
      dropdown: 'PhCaretDown',
      menuDown: 'PhCaretDown',
      menuUp: 'PhCaretUp',
      expand: 'PhCaretDown',
      collapse: 'PhCaretUp',
      calendar: 'PhCalendar',
      close: 'PhX',
      clear: 'PhX',
      edit: 'PhPencilSimple',
      error: 'PhX',
      checkboxOn: 'PhCheckSquare',
      checkboxOff: 'PhSquare',
      checkboxIndeterminate: 'PhMinusSquare',
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme
    }
  },
  aliases: {
    VBtnIcon: VBtn,
    VDateInput: VDateInput,
  },
  defaults: {
    VApp: {
      class: "bg-color",
      color: "primary",
    },
    VAppBar: {
      height: "76",
      class: "border-b",
      elevation: 0,
    },
    VBtn: {
      class: 'text-none',
      color: 'primary',
      variant: 'flat',
      block: false,
    },
    VSelect: {
      color: "primary",
      density: 'compact',
      variant: 'outlined'
    },
    VBtnIcon: {
      class: "pa-2",
      variant: "text"
    },
    VCard: {
      class: 'pa-4 rounded-lg',
      variant: 'elevated'
    },
    VDivider: {
      color: "secondary"
    },
    VList: {
      border: true,
      class: "pa-2 rounded-lg",
      elevation: "0",
    },
    VListItem: {
      class: "rounded-lg"
    },
    VMenu: {
      offset: "8"
    },
    VContainer: {
      fluid: true,
      class: "pa-6"
    },
    VTextField: {
      color: "primary",
      density: "compact",
      variant: "outlined"
    },
    VTextarea: {
      color: "primary",
      density: "compact",
      variant: "outlined"
    },
    VDataTable: {
      mobile: false,
      elevation: 0
    },
    VDateInput: {
      color: "primary",
      density: "compact",
      variant: "outlined"
    },
    VFileInput: {
      color: "primary",
      density: "compact",
      variant: "outlined"
    },
    VChip: {
      label: true
    }
  },
  components,
  directives
})
